
export const MEDIA_ROUTE = "media";
export const MOE_ROUTE = "moe";
export const EVENTS_ROUTE = "events";
export const GRAPH_ROUTE = "graph";
export const CONNECTOR_ROUTE = "connector";
export const DATA_CATALOG_ROUTE = "catalog";
export const EXPLORER_ROUTE = "explorer";
export const NARRATIVES_ROUTE = "narratives";
export const ENTITY_VIEW_ROUTE = "entities";
export const RESUMES_ROUTE = "resumes";
export const CORP_RECORDS_ROUTE = "corprecords";
export const SOCIAL_MEDIA_ROUTE = "social";
export const ASKSAGE_ROUTE = "asksage";
export const COMPARE_ROUTE = "compare";
export const WEB_PAGES_ROUTE = "web";
export const AGENTS_ROUTE = "agents";
export const VIDEO_ROUTE = "video";
export const HELP_ROUTE = "help";
export const CURATED_ROUTE = "curated";
export const CROSSTABS_ROUTE = "crosstabs";
export const REPORTS_ROUTE = "reports";

export const MEDIA_PATH = `/${MEDIA_ROUTE}`;
export const MOE_PATH = `/${MOE_ROUTE}`;
export const EVENTS_PATH = `/${EVENTS_ROUTE}`;
export const GRAPH_PATH = `/${GRAPH_ROUTE}`;
export const CONNECTOR_PATH = `/${CONNECTOR_ROUTE}`;
export const DATA_CATALOG_PATH = `/${DATA_CATALOG_ROUTE}`;
export const EXPLORER_PATH = `/${EXPLORER_ROUTE}`;
export const NARRATIVES_PATH = `/${NARRATIVES_ROUTE}`;
export const ENTITY_VIEW_PATH = `/${ENTITY_VIEW_ROUTE}`;
export const CORP_RECORDS_PATH = `/${CORP_RECORDS_ROUTE}`;
export const RESUMES_PATH = `/${RESUMES_ROUTE}`;
export const SOCIAL_MEDIA_PATH = `/${SOCIAL_MEDIA_ROUTE}`;
export const ASKSAGE_PATH = `/${ASKSAGE_ROUTE}`;
export const COMPARE_PATH = `/${COMPARE_ROUTE}`;
export const WEB_PAGES_PATH = `/${WEB_PAGES_ROUTE}`;
export const AGENTS_PATH = `/${AGENTS_ROUTE}`;
export const VIDEO_PATH = `/${VIDEO_ROUTE}`;
export const HELP_PATH = `/${HELP_ROUTE}`;
export const CURATED_PATH = `/${CURATED_ROUTE}`;
export const CROSSTABS_PATH = `/${CROSSTABS_ROUTE}`;
export const REPORTS_PATH = `/${REPORTS_ROUTE}`;

export const ENTITY_DISPLAY_ROUTES = [
  ENTITY_VIEW_ROUTE,
  CORP_RECORDS_ROUTE,
  RESUMES_ROUTE,
];

export const ENTITY_DISPLAY_PATHS = [
  ENTITY_VIEW_PATH,
  CORP_RECORDS_PATH,
  RESUMES_PATH,
];

export const ALL_PATHS = [
  MEDIA_PATH,
  MOE_PATH,
  EVENTS_PATH,
  GRAPH_PATH,
  CONNECTOR_PATH,
  DATA_CATALOG_PATH,
  EXPLORER_PATH,
  NARRATIVES_PATH,
  ENTITY_VIEW_PATH,
  CORP_RECORDS_PATH,
  RESUMES_PATH,
  SOCIAL_MEDIA_PATH,
  ASKSAGE_PATH,
  COMPARE_PATH,
  WEB_PAGES_PATH,
  AGENTS_PATH,
  VIDEO_PATH,
  HELP_PATH,
  CURATED_PATH,
  CROSSTABS_PATH,
  REPORTS_PATH,
];


export const GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME = "Original Language";
export const DEF_GOOGLE_TRANSLATE_LANGUAGE_NAME = GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME;
export const DEF_GOOGLE_TRANSLATE_LANGUAGE_ID = "";